import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
export default function FromQRCode() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const status_pro = searchParams.get("status_pro");
    const specialite = searchParams.get("specialite");
    const etablissement = searchParams.get("etablissement");
    const service = searchParams.get("service");
    const hopital = searchParams.get("hopital");

    window.localStorage.setItem(
      "onboarding",
      JSON.stringify({ status_pro, specialite, etablissement, service, hopital })
    );

    navigate("/");
  }, []);

  return <div>Chargement...</div>;
}
